import { render } from "./vderwithdrawalrecord.vue?vue&type=template&id=70dc696a&scoped=true"
import script from "./vderwithdrawalrecord.vue?vue&type=script&lang=js"
export * from "./vderwithdrawalrecord.vue?vue&type=script&lang=js"

import "./vderwithdrawalrecord.vue?vue&type=style&index=0&id=70dc696a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dc696a"]])

export default __exports__